import { enableOnlyIssueId } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/roadmap/timeline/schedule/actions';

export const mapDispatchToProps = { enableOnlyIssueId };
